import type { DatasetCartesianProps } from "./dataset-cartesian.type";

import { DatasetCard } from "@/modules/dataset/dataset-card";

import { DatasetCartesianEditor } from "./dataset-cartesian-editor";

export const DatasetCartesian = ({
  template,
  dataset,
  asset,
  loading,
  disabled,
}: DatasetCartesianProps) => {
  return (
    <DatasetCard
      datasetType="cartesian"
      template={template}
      dataset={dataset}
      loading={loading}
      disabled={disabled}
    >
      <DatasetCartesianEditor
        template={template}
        dataset={dataset}
        asset={asset}
        disabled={disabled}
      />
    </DatasetCard>
  );
};
